export const descriptionStyle = {
  marginTop: 3,
  marginBottom: 4,
  textAlign: { xs: 'center' }
};

export const subHeaderStyle = {
  marginBottom: 3,
  textAlign: { xs: 'center' }
};


export const buttonContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
};

export const buttonStyle = {
  marginTop: 4,
};